export enum EventNameAnalytics {
  LOGIN = 'login',
  /**
   * LOGIN_SUCCESS, when login is successfully
   */
  LOGIN_SUCCESS = 'login_success',
  /**
   * LOGIN_FAILED, when login is failed
   */
  ATTENDANCE = 'attendance',
  /**
   * ATTENDANCE_START, when user click record time
   */
  ATTENDANCE_START = 'attendance_start',
  /**
 * ATTENDANCE_START_TO_SEND, when sending record
 */
  ATTENDANCE_START_TO_SEND = 'attendance_start_to_send',
  /**
   * ATTENDANCE_PRESS_SAVE, when user press button Save Attendance
   */
  ATTENDANCE_PRESS_SAVE = 'attendance_press_save',
  /**
   * ATTENDANCE_CHECK_AUTO_TIME, attendance process check device user using manual time or automatic
   */
  ATTENDANCE_CHECK_AUTO_TIME = 'attendance_check_auto_time',
  /**
   * ATTENDANCE_CHECK_DEVELOPER_MODE, check developer mode
   */
  ATTENDANCE_CHECK_DEVELOPER_MODE = 'attendance_check_developer_mode',
  /**
   * ATTENDANCE_SKIP_CHECK_AUTO_TIME, attendance process  skip check device user using manual time or automatic
   */
  ATTENDANCE_SKIP_CHECK_AUTO_TIME = 'attendance_skip_check_auto_time',
  /**
   * ATTENDANCE_CHECK_MOCK_ROOT, attendance process check device is root or not, and check fake gps
   */
  ATTENDANCE_CHECK_ROOT_AND_MOCK_LOCATION = 'attendance_check_root_and_mock_location',
  /**
   * ATTENDANCE_GET_LOCATION, attendance process get current location 
   */
  ATTENDANCE_GET_LOCATION = 'attendance_get_location',
  /**
  * ATTENDANCE_GET_LOCATION, attendance process take picture
  */
  ATTENDANCE_GET_CAMERA = 'attendance_get_camera',
  /**
   * ATTENDANCE_GET_LOCATION, attendance process check radius absent
   */
  ATTENDANCE_CHECK_LOCATION_RADIUS = 'attendance_check_location_radius',
  /**
   * ATTENDANCE_GET_CURRENT_TIME, when attendance process get time from server or local
   */
  ATTENDANCE_GET_CURRENT_TIME = 'attendance_get_current_time',
  /**
   * ATTENDANCE_RECORD_CANCELLED, when user cancel take camera or maps
   */
  ATTENDANCE_RECORD_CANCELLED = 'attendance_record_cancelled',
  /**
   * ATTENDANCE_RECORD_SUCCESS, when record attendance is successfully sent
   */
  ATTENDANCE_RECORD_SUCCESS = 'attendance_record_success',
  /**
  * ATTENDANCE_BARCODE_RECORD_SUCCESS, when record attendance barcode is successfully sent
  */
  ATTENDANCE_BARCODE_RECORD_SUCCESS = 'attendance_barcode_record_success',
  /**
  * ATTENDANCE_BARCODE_RECORD_FAILED, when record attendance barcode is failed to send
  */
  ATTENDANCE_BARCODE_RECORD_FAILED = 'attendance_barcode_record_failed',
  /**
   * ATTENDANCE_FAILED_UPLOAD, when photo is failed to upload
   */
  ATTENDANCE_FAILED_UPLOAD = 'attendance_failed_upload',
  /**
   * ATTENDANCE_SUCCESS_UPLOAD, when photo is successfully sent
   */
  ATTENDANCE_SUCCESS_UPLOAD = 'attendance_success_upload',
  /**
   * ATTENDANCE_CHECK_FACE_DETECTION, check attendance face detection / recognition
   */
  ATTENDANCE_CHECK_FACE_DETECTION = 'attendance_check_face_detection',
  /**
   * ATTENDANCE_CHECK_FACE_DETECTION, check attendance face detection / recognition failed
   */
  ATTENDANCE_CHECK_FACE_DETECTION_FAILED = 'attendance_check_face_detection_failed',
  /**
  * ATTENDANCE_PREVIEW_TIMEOUT, timeout when too long stay on preview page
  */
  ATTENDANCE_PREVIEW_TIMEOUT = 'attendance_preview_timeout',
  /**
   * ATTENDANCE_CHECK_FACE_SPOOFING, check attendance face spoofing
   */
  ATTENDANCE_CHECK_FACE_SPOOFING = 'attendance_check_face_spoofing',
  /**
   * ATTENDANCE_CHECK_FACE_SPOOFING_SUCCESS, check attendance face spoofing success
   */
  ATTENDANCE_CHECK_FACE_SPOOFING_SUCCESS = 'attendance_check_face_spoofing_success',
  /**
  * ATTENDANCE_CHECK_FACE_SPOOFING_SUCCESS, check attendance face spoofing success
  */
  ATTENDANCE_CHECK_FACE_SPOOFING_FAILED = 'attendance_check_face_spoofing_failed',
  /**
   * ATTENDANCE_RECORD_FAILED,  when record attendance is failed to send
   */
  ATTENDANCE_RECORD_FAILED = 'attendance_record_failed',
  /**
   * ATTENDANCE_RECORD_SAVED_OFFLINE, when attendance record saved to offline
   */
  ATTENDANCE_RECORD_SAVED_OFFLINE = 'attendance_record_saved_offline',
  /**
   * ATTENDANCE_OFFLINE_TOTAL, total offline attendance
   */
  ATTENDANCE_OFFLINE_TOTAL = 'attendance_offline_total',
  /**
   * ATTENDANCE_OFFLINE_START, when user press record offline
   */
  ATTENDANCE_OFFLINE_START = 'attendance_offline_start',
  /**
   * ATTENDANCE_OFFLINE_START_TO_SEND, when start sending record offline
   */
  ATTENDANCE_OFFLINE_START_TO_SEND = 'attendance_offline_start_to_send',
  /**
   * ATTENDANCE_OFFLINE_SUCCESS_SENT, total attendance offline successfully sent
   */
  ATTENDANCE_OFFLINE_SUCCESS_SENT = 'attendance_offline_successfully_sent',
  /**
   * ATTENDANCE_OFFLINE_FAILED_SEND, total attendance offline failed to send
   */
  ATTENDANCE_OFFLINE_FAILED_SEND = 'attendance_offline_failed_to_send',
  /**
   * ATTENDANCE_OFFLINE_FAILED_SEND, total attendance offline failed to send
   */
  ATTENDANCE_FAILED_SEND_AWS = 'attendance_failed_send_aws',
  /**
   * ACTIVITY_RECORDING, when access page activity recording
   */
  ACTIVITY_RECORDING = 'activity_recording',
  /**
 * ACTIVITY_RECORDING_OFFLINE_TOTAL, total record offline 
 */
  ACTIVITY_RECORDING_OFFLINE_TOTAL = 'activity_recording_offline_total',
  /**
   * ACTIVITY_RECORDING, when access page activity recording
   */
  ACTIVITY_RECORDING_GET_CAMERA = 'activity_recording_get_camera',
  /**
   * ACTIVITY_RECORDING_CHECK_FAKE_GPS, check fake gps
   */
  ACTIVITY_RECORDING_CHECK_FAKE_GPS = 'activity_recording_fake_gps',
  /**
   * ACTIVITY_RECORDING_UPLOAD_SUCCESS, when success upload photo
   */
  ACTIVITY_RECORDING_UPLOAD_SUCCESS = 'activity_recording_upload_success',
  /**
   * ACTIVITY_RECORDING_UPLOAD_SUCCESS, when success upload photo
   */
  ACTIVITY_RECORDING_UPLOAD_FAILED = 'activity_recording_upload_failed',
  /**
   * ACTIVITY_RECORDING_START, when user press button add record activity
   */
  ACTIVITY_RECORDING_START = 'activity_recording_start',
  /**
   * ACTIVITY_RECORDING_PRESS_SAVE, when user press save/submit activity
   */
  ACTIVITY_RECORDING_PRESS_SAVE = 'activity_recording_press_save',
  /**
   * ACTIVITY_RECORDING_SUCCESS,when activity is successfully sent
   */
  ACTIVITY_RECORDING_SUCCESS = 'activity_recording_success',
  /**
   * ACTIVITY_RECORDING_SAVED_OFFLINE, when activity is saved to offline, cause not internet connection
   */
  ACTIVITY_RECORDING_SAVED_OFFLINE = 'activity_recording_saved_offline',
  /**
   * ACTIVITY_RECORDING_FAILED, when record activity failed send to server
   */
  ACTIVITY_RECORDING_FAILED = 'activity_recording_failed',
  /**
  * ACTIVITY_RECORDING_OFFLINE_START_TO_SEND, when user click send / send all activity recording offline
  */
  ACTIVITY_RECORDING_OFFLINE_START_TO_SEND = 'activity_recording_offline_start_to_send',
  /**
   * ACTIVITY_RECORDING_OFFLINE_SUCCESS_SENT, total offline is successfully sent
   */
  ACTIVITY_RECORDING_OFFLINE_SUCCESS_SENT = 'activity_recording_offline_success_sent',
  /**
   * ACTIVITY_RECORDING_OFFLINE_FAILED_SEND, total offline is failed to send
   */
  ACTIVITY_RECORDING_OFFLINE_FAILED_SEND = 'activity_recording_offline_failed_to_send',
  /**
   * LEAVE, when access leave
   */
  LEAVE = 'leave',
  /**
   * LEAVE_SAVE_DRAFT, when user press button save draft
   */
  LEAVE_SAVE_DRAFT = 'leave_save_draft',
  /**
   * LEAVE_SUBMIT, when user press button submit
   */
  LEAVE_SUBMIT = 'leave_submit',
  /**
   * LEAVE_REQUEST_SUCCESS, when request is successfully sent
   */
  LEAVE_REQUEST_SUCCESS = 'leave_request_success',
  /**
   * LEAVE_REQUEST_SUCCESS, when request is failed to send
   */
  LEAVE_REQUEST_FAILED = 'leave_request_failed',
  PATROL = 'patrol',
  PATROL_SUBMIT_SUCCESS = 'patrol_submit_success',
  PATROL_SUBMIT_FAILED = 'patrol_submit_failed',
  OVERTIME = 'overtime',
  OVERTIME_SAVE_DRAFT = 'overtime_save_draft',
  OVERTIME_SUBMIT = 'overtime_submit',
  OVERTIME_REQUEST_SUCCESS = 'overtime_request_success',
  OVERTIME_REQUEST_FAILED = 'overtime_request_failed',
  ATTENDANCE_CORRECTION = 'attendance_correction',
  ATTENDANCE_CORRECTION_SAVE_DRAFT = 'attendance_save_draft',
  ATTENDANCE_CORRECTION_SUBMIT = 'attendance_correction_submit',
  ATTENDANCE_CORRECTION_REQUEST_SUCCESS = 'attendance_correction_request_success',
  ATTENDANCE_CORRECTION_REQUEST_FAILED = 'attendance_correction_request_failed',
  BUSINESS_TRIP = 'business_trip',
  BUSINESS_TRIP_SAVE_DRAFT = 'business_trip_save_draft',
  BUSINESS_TRIP_SUBMIT = 'business_trip_submit',
  BUSINESS_TRIP_REQUEST_SUCCESS = 'business_trip_request_success',
  BUSINESS_TRIP_REQUEST_FAILED = 'business_trip_request_failed',
  LOGIN_FAILED = 'login_failed',
  COMPANY_ANNOUCEMENT = 'company_annoucement',
  COMPANY_POLICY = 'company_policy',
  ORGANIZATION_STRUCTURE = 'organization_structure',
  FORGOT_PASSWORD = 'forgot_password',
  FORGOT_PASSWORD_FAILED = 'forgot_password_failed',
  FORGOT_PASSWORD_RECRUITMENT = 'forgot_password_recruitment',
  FORGOT_PASSWORD_RECRUITMENT_FAILED = 'forgot_password_recruitment_failed',
  EMPLOYEE_INFORMARTION = 'employee_information',
  EMPLOYEE_INFORMARTION_VIEW_PROFILE = 'employee_information_view_profile',
  EMPLOYEE_INFORMARTION_VIEW_SOCIAL_MEDIA = 'employee_information_view_social_media',
  CAREER_ADMINISTRATION = 'career_administration',
  CAREER_SUBMIT_SUCCESS = 'career_submit_success',
  CAREER_SUBMIT_FAILED = 'career_submit_failed',
  CAREER_EDIT_SUBMIT_FAILED = 'career_edit_submit_failed',
  CAREER_EDIT_SUBMIT_SUCCESS = 'career_edit_submit_success',
  CAREER_DELETE_SUCCESS = 'career_delete_success',
  CAREER_DELETE_FAILED = 'career_delete_failed',
  PAYSLIP = 'payslip',
  PAYSLIP_DOWNLOAD = 'payslip_download',
  PAYSLIP_DETAIL = 'payslip_detail',
  PAYROLL = 'payroll',
  PUSH_NOTIFICATION = 'push_notification',
  REPORT = 'report',
  REPORT_DOWNLOAD_EXCEL = 'report_download_excel',
  REPORT_DOWNLOAD_PDF = 'report_download_pdf',
  REPORT_PREVIEW = 'report_preview',
  REPORT_SEND_MAIL = 'report_send_mail',
  CLAIM = 'claim',
  CLAIM_REQUEST_SUCCESS = 'claim_request_success',
  CLAIM_REQUEST_FAILED = 'claim_request_failed',
  TRACKING = 'tracking',
  TRACKING_START = 'tracking_start',
  TRACKING_START_FAILED = 'tracking_start_failed',
  TRACKING_RESTART = 'tracking_restart',
  TRACKING_CHECK_SHIFT_TRACKER = 'tracking_check_shift_tracker',
  TRACKING_CHECK_STATUS_TRACKER = 'tracking_check_status_tracker',
  TRACKING_CHECK_STATUS_TRACKER_FAILED = 'tracking_check_status_tracker_failed',
  TRACKING_STOP = 'tracking_stop',
  TRACKING_STOP_FAILED = 'tracking_stop_failed',
  TRACKING_CLEAR_INTERVAL_FAILED = 'tracking_clear_interval',
  TRACKING_SAVE_LOG = 'tracking_save_log',
  TRACKING_SAVE_LOG_FAILED = 'tracking_save_log_failed',
  TRACKING_GET_LOCATION = 'tracking_get_location',
  TRACKING_GET_LOCATION_FAILED = 'tracking_get_location_faileds',
  COMPANY_MOOD = 'company_mood',
  GREATDAY_EVENT = 'greatday_event',
  GREATDAY_FEEDS = 'greatday_feeds',
  GREATDAY_FEEDS_ADD_POST = 'greatday_feeds_add_post',
  GREATDAY_FEEDS_ADD_POST_FAILED = 'greatday_feeds_add_post_failed',
  GREATDAY_FEEDS_LIKE_POST = 'greatday_feeds_like_post',
  GREATDAY_FEEDS_LIKE_POST_FAILED = 'greatday_feeds_like_post_failed',
  GREATDAY_FEEDS_COMMENT_POST = 'greatday_feeds_comment_post',
  GREATDAY_FEEDS_COMMENT_POST_FAILED = 'greatday_feeds_comment_post_failed',
  GREATDAY_MEET = 'greatday_meet',
  ID_CARD = 'id_card',
  ID_CARD_GENERATE = 'id_card_generate',
  ID_CARD_GENERATE_FAILED = 'id_card_generate_failed',
  PANIC_BUTTON = 'panic_button',
  PANIC_BUTTON_PRESS_SOS = 'panic_button_press_sos',
  PANIC_BUTTON_CONTACT_LIST = 'panic_button_contact_list',
  PERFORMANCE = 'performance',
  POLLING = 'polling',
  POLLING_CREATE = 'polling_create',
  POLLING_FILL = 'polling_fill',
  RECRUITMENT = 'recruitment',
  SOCIAL_MEDIA = 'social_media',
  SUBSCRIPTION_MANAGER = 'subscription_manager',
  TASK_AND_FEEDBACK = 'task_and_feedback',
  TASK_AND_FEEDBACK_CREATE_TASK = 'task_and_feedback_create_task',
  TASK_AND_FEEDBACK_CREATE_FEEDBACK = 'task_and_feedback_create_feedback',
  TIMESHEET = 'timesheet',
  WHISTLE_BLOWER = 'whistle_blower',
  OPEN_PAGE = 'open_page',
  OPEN_MENU = 'open_menu',
  OPEN_TABS = 'open_tabs',
  OPEN_WEBVIEW = 'open_webview',
  NETWORK = 'network',
  RATING = 'rating',
  RATING_GIVE_RATE = 'rating_give_rate',
  START_TRACKER_WITH_ID = 'start_tracker_with_id',
  START_TRACKER_WITH_ID_FAILED = 'start_tracker_with_id_failed',
  APP_VERSION = 'app_version',
  APP_VERSION_FAILED = 'app_version_failed',
  RESET_PASSWORD_SUCCESS = 'reset_password_success',
  RESET_PASSWORD_FAILED = 'reset_password_failed',
}


// WEBPACK FOOTER //
// ./src/helpers/event-name-analytics.ts